// @flow
import cookiesPolicy                 from './components/CookiesPolicy/index';
cookiesPolicy({
  position: 'bottom',
  enableSplitGTMContainer: true,
  enableOneGTMContainer: true,
});

import connectWebActions             from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';
import phoneLink                     from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';

import configureWebComponents from './configureWebComponents';
import configureWebActions    from './configureWebActions';
//import('./components/plUpload/fg.upload');                // PL upload
//import 'bootstrap/js/dist/collapse';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();
phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();

import Tabby from 'tabbyjs/dist/js/tabby.min';

const fulltextResltsPage = document.querySelector('.page-container--fulltext');
if (fulltextResltsPage) {
  document.body.classList.add('fulltext-results');
	// Tabby js for fulltext
	const tabs = new Tabby('[data-tabs]');

	// Toggling category tab
	if (tabs) {

		setTimeout(() => {
			const tabbyContent = document.querySelector('.fulltext-results-container');
			if (tabbyContent) tabbyContent.classList.remove('fulltext-results-container--hidden');
			const tabsItems = document.querySelectorAll('.fulltext-controls__link');

			const urlString = window.location.href;
			const url = new URL(urlString);
			const section = url.searchParams.get('section');

			if (tabsItems) {
				if (section) {
					const preferedItem = document.getElementById(`tabby-toggle_${ section }`);
					preferedItem.click(); // click on prefered tab (link form Autocomplete section)
				} else {
					let containsProductsResults = false;
					tabsItems.forEach((item, index) => {
						const attr = item.getAttribute('href');
						if (attr === '#fulltextResultsContainerProducts') {
              // console.log('containsProductsResults=true');
              containsProductsResults = true;
            }
					});
					if (containsProductsResults) {
            const productTab = document.querySelector('[aria-controls=fulltextResultsContainerProducts]');// find product tab
            // console.log('productTab Element = ', productTab);
            productTab.click(); // and click o it
					} else {
						tabsItems[ 0 ].click(); // first item click
					}
				}
			}
		}, 200);

		document.addEventListener('tabby', (event) => {
			const content = event.detail.content;
			content.classList.remove('hidden');
		}, false);
	}
}








// WEBPACK FOOTER //
// ./fe/web-cigarhouse/src/js/configureWeb.js